const Style = `
  <style>
    .feature-list-container {
      background: #f1f9f7;
      padding: 24px 24px 35px;
    }
    .feature-list-container__wrapper {
      display: flex;
      flex-direction: column;
      gap: 44px;
      max-width: 1440px;
      margin: 0 auto;
    }
    .feature-list-container__text{
      display: flex;
      gap: 50px;
      flex-direction: row;
    }
    .feature-list-container__headline {
      font-family: Spectral-ExtraLight,HelveticaNeue,Helvetica Neue,Helvetica,Arial,sans-serif;
      width: 40%;
      font-size: 50px;
      line-height: 54px;
      letter-spacing: -1px;
    }
    .feature-list-container__subheadline {
      max-width: 660px;
      width: 60%;
      margin-left: auto;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: .32px;
    }
    .feature-text:before {
      speak: none;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      color: #8ae5d3;
      content: "";
      font-family: onerockwell !important;
      font-size: 30px;
      font-style: normal;
      font-variant: normal;
      font-weight: 400;
      text-indent: 0;
      text-transform: none;
    }
    .slider-container {
      max-width: 1440px;
      margin: 0 auto;
    }
    .slick-list {
      position: relative;
      display: block;
      overflow: hidden;
      margin: 0;
      padding: 0;
    }
    .slick-initialized .slick-slide {
      display: block;
      margin-top: 0;
      margin-bottom: 0;
    }
    .slick-slide {
      display: none;
      float: left;
      height: 100%;
    }
    @media (max-width: 768px) {
      .feature-list-container__text {
        flex-direction: column;
        gap: 10px;
      }
      .feature-list-container__headline {
        width: 100%;
        margin: 0;
      }
      .feature-list-container__subheadline {
        width: 100%;
      }
    }
  </style>
`;

export default Style;
